import React, { Component } from 'react'
import gql from 'graphql-tag'

import { graphql } from '@apollo/client/react/hoc'
import { Container, Col, Row, Label, Input, Alert, UncontrolledTooltip } from 'reactstrap'
import Skeleton from "react-loading-skeleton"
import moment from "moment"
import UpdateUser from "../UpdateUser"
import { AllGroups, AllBranches, UserPermissions } from "../../Queries"
import Button from "reactstrap/lib/Button"
import "./OverviewTab.css"
import { HasPermissionsQuery } from "../../../Functions/querys"

import withApolloClient from '../../../withApolloClient'

const UpdateUserMutation = gql`
mutation UpdateUser($input: UpdateUserMutationInput!){
    updateUser(input:$input){
        ok
        errors{
            messages
        }
    }
} `
const PAGE_SIZE = 30
const MembersDetailQuery = gql`query Member($id: ID!){
    member(id: $id) {
      id
      type
      dateAdded
      dateModified
      selectedBranches {
        edges {
          node {
            id
            name
          }
        }
      }
      tenant {
        id
        name
      }
      user {
        id
        username
        email
        firstName
        lastName
        isActive
        isStaff
        lastLogin
        dateJoined
        groups {
          edges {
            node {
              id
              name
            }
          }
        }
      }
      branches {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }  
`

class OverviewTab extends Component {
    constructor(props) {
        super(props)
        this.state = {
            error: null,
            loading: false,
            openModal: "",
            assignedGroups: [],
            assignedPermissions: [],
            assignedBranches: [],
            selectedBranchIds: [],
            selectedAvailableGroupIds: [],
            selectedAssignedGroupIds: [],
            selectedAvailableBranchIds: [],
            selectedAssignedBranchIds: [],
            selectedAvailableSelectedBranchIds: [],
            selectedSelectedBranchIds: [],
            groupsLoadingMore: false,
            groupSearchTerm: "",
            branchSearchTerm: "",
            selectedBranchSearhTerm: "",
            disableUpdateBtn: true,
            input: {},
        }
    }

    toggleModal = (modalName) => {
        if (this.state.openModal === modalName) {
            this.setState({ openModal: "" })
        } else {
            this.setState({ openModal: modalName })
        }
    }

    updateUser = () => {
        if (this.props.member && this.props.member.user && this.props.member.user.id) {
            this.setState({ loading: true })
            let input = this.state.input
            input["userId"] = this.props.member && this.props.member.user && this.props.member.user.id
            if (this.state.assignedGroups)
                input["groups"] = this.state.assignedGroups.map(item => { return item.value })
            if (this.state.assignedPermissions)
                input["userPermissions"] = this.state.assignedPermissions.map(item => { return item.value })
            if (this.state.assignedBranches)
                input["branchIds"] = this.state.assignedBranches.map(item => { return item.value })
            if (this.state.selectedBranchIds)
                input["selectedBranches"] = this.state.selectedBranchIds.map(item => { return item.value })
            this.props.apolloClient.mutate({
                mutation: UpdateUserMutation,
                variables: { input },
            }).then((result) => {
                if (result && result.data && result.data.updateUser && result.data.updateUser.ok) {
                    this.props.refetchQuery()
                    this.props.refetchUserPermissionsQuery()
                    this.setState({ input: {}, loading: false, error: null })
                } else if (result.data.updateUser && result.data.updateUser.errors) {
                    this.setState({ loading: false, error: String(result.data.updateUser.errors[0].messages) })
                } else {
                    this.setState({ loading: false, error: "An error has occurred. Please check your input or contact admin." })
                }
            }).catch((err) => {
                this.setState({ loading: false, error: "An error has occurred. Please contact admin." })
            })
        } else {
        }
    }

    addSelectedItems = (selectedKey, targetKey, sourceItems, searchKey) => {
        const selectedIds = this.state[selectedKey]
        if (!selectedIds.length) {
            return
        }
        const hadSearch = searchKey ? Boolean(this.state[searchKey]) : false
        const selectedItems = sourceItems.filter((item) => selectedIds.includes(item.value))
        const merged = new Map(this.state[targetKey].map((item) => [item.value, item]))
        selectedItems.forEach((item) => merged.set(item.value, item))
        const nextState = {
            [targetKey]: Array.from(merged.values()),
            [selectedKey]: [],
            disableUpdateBtn: false,
        }
        if (searchKey) {
            nextState[searchKey] = ""
        }
        this.setState(nextState, () => {
            if (!hadSearch) {
                return
            }
            if (searchKey === "groupSearchTerm" && this.props.allGroupsRefetch) {
                this.props.allGroupsRefetch({
                    first: PAGE_SIZE,
                    cursor: null,
                    name_Icontains: null,
                })
            }
        })
    };

    removeSelectedItems = (selectedKey, targetKey) => {
        const selectedIds = new Set(this.state[selectedKey])
        if (!selectedIds.size) {
            return
        }
        const updatedItems = this.state[targetKey].filter((item) => !selectedIds.has(item.value))
        this.setState({
            [targetKey]: updatedItems,
            [selectedKey]: [],
            disableUpdateBtn: false,
        })
    };

    removeAllItems = (targetKey, selectedKey) => {
        if (!this.state[targetKey].length) {
            return
        }
        this.setState({
            [targetKey]: [],
            [selectedKey]: [],
            disableUpdateBtn: false,
        })
    };

    handleGroupSearchChange = (event) => {
        const value = event.target.value
        this.setState({ groupSearchTerm: value })
        if (this.props.allGroupsRefetch) {
            this.props.allGroupsRefetch({
                first: PAGE_SIZE,
                cursor: null,
                name_Icontains: value || null,
            })
        }
    };

    loadMoreGroups = () => {
        const { allGroupsFetchMore, allGroups, allGroupsVariables } = this.props
        if (!allGroupsFetchMore || !allGroups || !allGroups.pageInfo || !allGroups.pageInfo.hasNextPage) {
            return
        }
        this.setState({ groupsLoadingMore: true })
        return allGroupsFetchMore({
            query: AllGroups,
            variables: {
                ...allGroupsVariables,
                first: PAGE_SIZE,
                cursor: allGroups.pageInfo.endCursor,
                name_Icontains: this.state.groupSearchTerm || null,
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
                if (!fetchMoreResult || !fetchMoreResult.allGroups) {
                    return previousResult
                }
                return {
                    allGroups: {
                        edges: [...previousResult.allGroups.edges, ...fetchMoreResult.allGroups.edges],
                        pageInfo: fetchMoreResult.allGroups.pageInfo,
                        __typename: previousResult.allGroups.__typename,
                    },
                }
            },
        }).finally(() => {
            this.setState({ groupsLoadingMore: false })
        })
    };

    updateMemberStates = () => {
        let assignedGroupsArr = []
        let assignedBranchesArr = []
        let selectedBranchesArr = []
        if (this.props.member && this.props.member.user && this.props.member.user.groups && this.props.member.user.groups.edges && this.props.member.user.groups.edges.length > 0) {
            this.props.member.user.groups.edges.map((item) =>
                assignedGroupsArr.push({ value: item.node.id, label: item.node.name })
            )
        }
        if (this.props.member && this.props.member.branches && this.props.member.branches.edges && this.props.member.branches.edges.length > 0) {
            this.props.member.branches.edges.map((item) =>
                assignedBranchesArr.push({ value: item.node.id, label: item.node.name })
            )
        }
        if (this.props.member && this.props.member.selectedBranches && this.props.member.selectedBranches.edges && this.props.member.selectedBranches.edges.length > 0) {
            this.props.member.selectedBranches.edges.map((item) =>
                selectedBranchesArr.push({ value: item.node.id, label: item.node.name })
            )
        }
        this.setState({
            assignedGroups: assignedGroupsArr,
            assignedBranches: assignedBranchesArr,
            selectedBranchIds: selectedBranchesArr,
            selectedAvailableGroupIds: [],
            selectedAssignedGroupIds: [],
            selectedAvailableBranchIds: [],
            selectedAssignedBranchIds: [],
            selectedAvailableSelectedBranchIds: [],
            selectedSelectedBranchIds: [],
        })
    }

    updatePermissionsStates = () => {
        let assignedPermissionsArr = []
        if (this.props.userPermissions && this.props.userPermissions.edges && this.props.userPermissions.edges.length > 0) {
            this.props.userPermissions.edges.map((item) =>
                assignedPermissionsArr.push({ value: item.node.id, label: item.node.name })
            )
        }
        this.setState({ assignedPermissions: assignedPermissionsArr })
    }

    componentDidUpdate(prevProps) {
        if (this.props.member !== prevProps.member) {
            this.updateMemberStates()
        }
        if (this.props.userPermissions !== prevProps.userPermissions) {
            this.updatePermissionsStates()
        }
    }

    componentDidMount() {
        if (this.props.member) {
            this.updateMemberStates()
        }
        if (this.props.userPermissions) {
            this.updatePermissionsStates()
        }
    }

    render() {
        const assignedGroupsIds = this.state.assignedGroups.map((group) => group.value)
        const assignedBranchIds = this.state.assignedBranches.map((assignedBranch) => assignedBranch.value)
        const selectedBranchIds = this.state.selectedBranchIds.map((selectedBranch) => selectedBranch.value)
        const availableGroupsAll = (this.props.allGroups?.edges || [])
            .filter(item => !assignedGroupsIds.some(groupId => groupId === item.node.id))
            .map(item => ({ value: item.node.id, label: item.node.name }))
        const filteredAvailableGroups = availableGroupsAll
        const availableBranchesAll = (this.props.allBranches?.edges || [])
            .filter(item => !assignedBranchIds.some(branchId => branchId === item.node.id))
            .map(item => ({ value: item.node.id, label: item.node.name }))
        const filteredAvailableBranches = this.state.branchSearchTerm
            ? availableBranchesAll.filter(item => item.label.toLowerCase().includes(this.state.branchSearchTerm.toLowerCase()))
            : availableBranchesAll
        const availableSelectedBranchesAll = this.state.assignedBranches
            .filter(item => !selectedBranchIds.some(branchId => branchId === item.value))
        const filteredAvailableSelectedBranches = this.state.selectedBranchSearhTerm
            ? availableSelectedBranchesAll.filter(item => item.label.toLowerCase().includes(this.state.selectedBranchSearhTerm.toLowerCase()))
            : availableSelectedBranchesAll
        const groupsHasNextPage = this.props.allGroups?.pageInfo?.hasNextPage || false
        return (
            <Container fluid className="member-detail">
                {this.props.loading || this.state.loading || !this.props.member ? (
                    <div className="overview-page-skeleton">
                        <Skeleton count={6} height={24} />
                    </div>
                ) : <>
                    {this.state.error && <Row><Col xs={12}><Alert color="danger">{this.state.error}</Alert></Col></Row>}
                    <Row className="overview-info-row">
                        <Col className="overview-info-card">
                            <Row className='mb-4'>
                                <Col>
                                    <Label>Date Added</Label>
                                    <Input disabled className="box-object-property-input" value={moment(this.props.member.dateAdded).tz("America/New_York").format('lll')} />
                                </Col>
                                <Col>
                                    <Label>Date Modified</Label>
                                    <Input disabled className="box-object-property-input" value={moment(this.props.member.dateModified).tz("America/New_York").format('lll')} />
                                </Col>
                                <Col>
                                    <Label>Username</Label>
                                    <Input disabled className="box-object-property-input" value={this.props.member && this.props.member.user && this.props.member.user.username ? this.props.member.user.username : "--"} />
                                </Col>
                                <Col>
                                    <Label>Tenant</Label>
                                    <Input disabled className="box-object-property-input" value={this.props.member && this.props.member.tenant && this.props.member.tenant.name ? this.props.member.tenant.name : "--"} />
                                </Col>
                            </Row>
                            <Row className='mb-4'>
                                <Col>
                                    <Label className='d-flex justify-content-between align-items-center'>First Name {this.props.hasPermissions && this.props.hasPermissions.includes("change_member") && <i className="fa fa-pencil-square fa-lg" aria-hidden="true" onClick={() => this.toggleModal('firstNameEdit')} />}</Label>
                                    <Input id={"firstNameEdit"} disabled className="box-object-property-input" value={this.props.member && this.props.member.user && this.props.member.user.firstName ? this.props.member.user.firstName : "--"} />
                                    {this.state.openModal === 'firstNameEdit' &&
                                        <UpdateUser
                                            userId={this.props.member && this.props.member.user && this.props.member.user.id}
                                            title="Edit First Name"
                                            name="firstName"
                                            value={this.props.member && this.props.member.user && this.props.member.user.firstName && this.props.member.user.firstName}
                                            target="firstNameEdit"
                                            type="text"
                                            open={this.state.openModal === 'firstNameEdit'}
                                            handleClose={() => this.toggleModal("")}
                                            refetchQuery={this.props.refetchQuery}
                                        />
                                    }
                                </Col>
                                <Col>
                                    <Label className='d-flex justify-content-between align-items-center'>Last Name {this.props.hasPermissions && this.props.hasPermissions.includes("change_member") && <i className="fa fa-pencil-square fa-lg" aria-hidden="true" onClick={() => this.toggleModal('lastNameEdit')} />}</Label>
                                    <Input id={"lastNameEdit"} disabled className="box-object-property-input" value={this.props.member && this.props.member.user && this.props.member.user.lastName ? this.props.member.user.lastName : "--"} />
                                    {this.state.openModal === 'lastNameEdit' &&
                                        <UpdateUser
                                            userId={this.props.member && this.props.member.user && this.props.member.user.id}
                                            title="Edit Last Name"
                                            name="lastName"
                                            value={this.props.member && this.props.member.user && this.props.member.user.lastName && this.props.member.user.lastName}
                                            target="lastNameEdit"
                                            type="text"
                                            open={this.state.openModal === 'lastNameEdit'}
                                            handleClose={() => this.toggleModal("")}
                                            refetchQuery={this.props.refetchQuery}
                                        />
                                    }
                                </Col>
                                <Col>
                                    <Label className='d-flex justify-content-between align-items-center'>Email {this.props.hasPermissions && this.props.hasPermissions.includes("change_member") && <i className="fa fa-pencil-square fa-lg" aria-hidden="true" onClick={() => this.toggleModal('emailEdit')} />}</Label>
                                    <Input id={"emailEdit"} disabled className="box-object-property-input" value={this.props.member && this.props.member.user && this.props.member.user.email ? this.props.member.user.email : "--"} />
                                    {this.state.openModal === 'emailEdit' &&
                                        <UpdateUser
                                            userId={this.props.member && this.props.member.user && this.props.member.user.id}
                                            title="Edit Last Name"
                                            name="email"
                                            value={this.props.member && this.props.member.user && this.props.member.user.email && this.props.member.user.email}
                                            target="emailEdit"
                                            type="text"
                                            open={this.state.openModal === 'emailEdit'}
                                            handleClose={() => this.toggleModal("")}
                                            refetchQuery={this.props.refetchQuery}
                                        />
                                    }
                                </Col>
                                <Col>
                                    <Label className='d-flex justify-content-between align-items-center'>Member Type {<i className="fa fa-pencil-square fa-lg" aria-hidden="true" onClick={() => this.toggleModal('memberTypeEdit')} />}</Label>
                                    <Input id={"memberTypeEdit"} disabled className="box-object-property-input" value={this.props.member && this.props.member.type ? this.props.member.type : "--"} />
                                    {this.state.openModal === 'memberTypeEdit' &&
                                        <UpdateUser
                                            userId={this.props.member && this.props.member.user && this.props.member.user.id}
                                            title="Edit Member Type"
                                            name="memberType"
                                            value={this.props.member && this.props.member.type && this.props.member.type.toLowerCase()}
                                            target="memberTypeEdit"
                                            type="select"
                                            open={this.state.openModal === 'memberTypeEdit'}
                                            handleClose={() => this.toggleModal("")}
                                            refetchQuery={this.props.refetchQuery}
                                        />
                                    }
                                </Col>
                            </Row>
                            <Row className='mt-2'>
                                <Col>
                                    <Label className='d-flex justify-content-between align-items-center' id="isStaffEdit">Is Staff {this.props.hasPermissions && this.props.hasPermissions.includes("custom_can_edit_member_sensitive_info") && <i className="fa fa-pencil-square fa-lg" aria-hidden="true" onClick={() => this.toggleModal('isStaffEdit')} />}</Label><br />
                                    {this.state.openModal === 'isStaffEdit' &&
                                        <UpdateUser
                                            userId={this.props.member && this.props.member.user && this.props.member.user.id}
                                            title="Edit Is Staff Status"
                                            name="isStaff"
                                            value={this.props.member.user.isStaff}
                                            target="isStaffEdit"
                                            type="boolean"
                                            open={this.state.openModal === 'isStaffEdit'}
                                            handleClose={() => this.toggleModal("")}
                                            refetchQuery={this.props.refetchQuery}
                                        />
                                    }
                                    <span>YES</span>
                                    <div className="toggle-switch">
                                        <input
                                            type="checkbox"
                                            className="toggle-switch-checkbox"
                                            name="isStaff"
                                            id="isStaffEdit"
                                            disabled
                                            checked={!this.props.member.user.isStaff}
                                        />
                                        <label className="toggle-switch-label" htmlFor="isStaffEdit">
                                            <span className="toggle-switch-inner" />
                                            <span className="toggle-switch-switch" />
                                        </label>
                                    </div>
                                    <span>NO</span>
                                </Col>
                                <Col>
                                    <Label className='d-flex justify-content-between align-items-center' id="isActiveEdit">Is Active {this.props.hasPermissions && this.props.hasPermissions.includes("custom_can_edit_member_sensitive_info") && <i className="fa fa-pencil-square fa-lg" aria-hidden="true" onClick={() => this.toggleModal('isActiveEdit')} />}</Label><br />
                                    {this.state.openModal === 'isActiveEdit' &&
                                        <UpdateUser
                                            userId={this.props.member && this.props.member.user && this.props.member.user.id}
                                            title="Edit Is Active Status"
                                            name="isActive"
                                            value={this.props.member.user.isActive}
                                            target="isActiveEdit"
                                            type="boolean"
                                            open={this.state.openModal === 'isActiveEdit'}
                                            handleClose={() => this.toggleModal("")}
                                            refetchQuery={this.props.refetchQuery}
                                        />
                                    }
                                    <span>YES</span>
                                    <div className="toggle-switch">
                                        <input
                                            type="checkbox"
                                            className="toggle-switch-checkbox"
                                            name="isActive"
                                            id="isActiveEdit"
                                            disabled
                                            checked={!this.props.member.user.isActive}
                                        />
                                        <label className="toggle-switch-label" htmlFor="isActiveEdit">
                                            <span className="toggle-switch-inner" />
                                            <span className="toggle-switch-switch" />
                                        </label>
                                    </div>
                                    <span>NO</span>
                                </Col>
                                <Col>
                                    <Label>Date Joined</Label>
                                    <Input disabled className="box-object-property-input" value={moment(this.props.member.user.dateJoined).tz("America/New_York").format('lll')} />
                                </Col>
                                <Col>
                                    <Label>Last Login</Label>
                                    <Input disabled className="box-object-property-input" value={moment(this.props.member.user.lastLogin).tz("America/New_York").format('lll')} />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="overview-branch-row">
                        <Col xs={6}>
                            <Row>
                                <Col md={5} className="overview-card">
                                    <div className="overview-card-header">
                                        <span>Available Branches</span>
                                        <span className="overview-count">{filteredAvailableBranches.length}</span>
                                    </div>
                                    <div className="overview-search">
                                        <Input
                                            className="overview-search-input"
                                            name="branchSearchTerm"
                                            id="branchSearchTerm"
                                            value={this.state.branchSearchTerm}
                                            onChange={(event) => this.setState({ branchSearchTerm: event.target.value })}
                                            placeholder="Search branches..."
                                        />
                                    </div>
                                    <div className="overview-list">
                                        {this.props.allBranchesLoading ? (
                                            <div className="overview-list-skeleton">
                                                <Skeleton count={8} height={18} />
                                            </div>
                                        ) : (
                                            filteredAvailableBranches.length === 0 ? <div className="overview-no-data">No branches available.</div> :
                                                <Input
                                                    type="select"
                                                    multiple
                                                    className="overview-select"
                                                    value={this.state.selectedAvailableBranchIds}
                                                    onChange={(event) => {
                                                        const selected = Array.from(event.target.selectedOptions).map((option) => option.value)
                                                        this.setState({ selectedAvailableBranchIds: selected })
                                                    }}
                                                >
                                                    {filteredAvailableBranches.map((item) => (
                                                        <option key={item.value} value={item.value}>{item.label}</option>
                                                    ))}
                                                </Input>
                                        )}
                                    </div>
                                </Col>
                                <Col md={2} className="overview-transfer">
                                    <Button
                                        onClick={() => this.addSelectedItems("selectedAvailableBranchIds", "assignedBranches", filteredAvailableBranches)}
                                        className="transfer-btn"
                                        disabled={!this.props.hasPermissions?.includes("change_member") || !this.state.selectedAvailableBranchIds.length}
                                        id="av-branches-right-arrow"
                                    >
                                        <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                    </Button>
                                    {!this.props.hasPermissions?.includes("change_member") && (
                                        <UncontrolledTooltip placement="right" target="av-branches-right-arrow">
                                            User don't have enough permission to perform this action
                                        </UncontrolledTooltip>
                                    )}
                                    <Button
                                        onClick={() => this.removeSelectedItems("selectedAssignedBranchIds", "assignedBranches")}
                                        className="transfer-btn"
                                        disabled={!this.props.hasPermissions?.includes("change_member") || !this.state.selectedAssignedBranchIds.length}
                                        id="av-branches-left-arrow"
                                    >
                                        <i className="fa fa-chevron-left" aria-hidden="true"></i>
                                    </Button>
                                    {!this.props.hasPermissions?.includes("change_member") && (
                                        <UncontrolledTooltip placement="right" target="av-branches-left-arrow">
                                            User don't have enough permission to perform this action
                                        </UncontrolledTooltip>
                                    )}
                                </Col>
                                <Col md={5} className="overview-card">
                                    <div className="overview-card-header">
                                        <span>Assigned Branches</span>
                                        <span className="overview-count">{this.state.assignedBranches.length}</span>
                                    </div>
                                    <div className="overview-list">
                                        {this.props.allBranchesLoading ? (
                                            <div className="overview-list-skeleton">
                                                <Skeleton count={8} height={18} />
                                            </div>
                                        ) : (
                                            this.state.assignedBranches.length === 0 ? <div className="overview-no-data">No branches assigned.</div> :
                                                <Input
                                                    type="select"
                                                    multiple
                                                    className="overview-select"
                                                    value={this.state.selectedAssignedBranchIds}
                                                    onChange={(event) => {
                                                        const selected = Array.from(event.target.selectedOptions).map((option) => option.value)
                                                        this.setState({ selectedAssignedBranchIds: selected })
                                                    }}
                                                >
                                                    {this.state.assignedBranches.map((item) => (
                                                        <option key={item.value} value={item.value}>{item.label}</option>
                                                    ))}
                                                </Input>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                            <Row className="overview-bulk-row">
                                <Col md={5} className="overview-bulk-col"></Col>
                                <Col md={2}></Col>
                                <Col md={5} className="overview-bulk-col">
                                    <span
                                        className={`overview-bulk-link ${!this.state.assignedBranches.length || !this.props.hasPermissions?.includes("change_member") ? "is-disabled" : ""}`}
                                        role="button"
                                        tabIndex={0}
                                        onClick={() => {
                                            if (this.state.assignedBranches.length && this.props.hasPermissions?.includes("change_member")) {
                                                this.removeAllItems("assignedBranches", "selectedAssignedBranchIds")
                                            }
                                        }}
                                    >
                                        <i className="fa fa-chevron-circle-left" aria-hidden="true"></i> Remove All
                                    </span>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={6}>
                            <Row>
                                <Col md={5} className="overview-card">
                                    <div className="overview-card-header">
                                        <span>Available Selected Branches</span>
                                        <span className="overview-count">{filteredAvailableSelectedBranches.length}</span>
                                    </div>
                                    <div className="overview-search">
                                        <Input
                                            className="overview-search-input"
                                            name="selectedBranchSearhTerm"
                                            id="selectedBranchSearhTerm"
                                            value={this.state.selectedBranchSearhTerm}
                                            onChange={(event) => this.setState({ selectedBranchSearhTerm: event.target.value })}
                                            placeholder="Search selected branches..."
                                        />
                                    </div>
                                    <div className="overview-list">
                                        {filteredAvailableSelectedBranches.length === 0 ? <div className="overview-no-data">No branches available.</div> :
                                            <Input
                                                type="select"
                                                multiple
                                                className="overview-select"
                                                value={this.state.selectedAvailableSelectedBranchIds}
                                                onChange={(event) => {
                                                    const selected = Array.from(event.target.selectedOptions).map((option) => option.value)
                                                    this.setState({ selectedAvailableSelectedBranchIds: selected })
                                                }}
                                            >
                                                {filteredAvailableSelectedBranches.map((item) => (
                                                    <option key={item.value} value={item.value}>{item.label}</option>
                                                ))}
                                            </Input>
                                        }
                                    </div>
                                </Col>
                                <Col md={2} className="overview-transfer">
                                    <Button
                                        onClick={() => this.addSelectedItems("selectedAvailableSelectedBranchIds", "selectedBranchIds", filteredAvailableSelectedBranches)}
                                        className="transfer-btn"
                                        disabled={!this.props.hasPermissions?.includes("change_member") || !this.state.selectedAvailableSelectedBranchIds.length}
                                        id="av-selected-branches-right-arrow"
                                    >
                                        <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                    </Button>
                                    {!this.props.hasPermissions?.includes("change_member") && (
                                        <UncontrolledTooltip placement="right" target="av-selected-branches-right-arrow">
                                            User don't have enough permission to perform this action
                                        </UncontrolledTooltip>
                                    )}
                                    <Button
                                        onClick={() => this.removeSelectedItems("selectedSelectedBranchIds", "selectedBranchIds")}
                                        className="transfer-btn"
                                        disabled={!this.props.hasPermissions?.includes("change_member") || !this.state.selectedSelectedBranchIds.length}
                                        id="av-selected-branches-left-arrow"
                                    >
                                        <i className="fa fa-chevron-left" aria-hidden="true"></i>
                                    </Button>
                                    {!this.props.hasPermissions?.includes("change_member") && (
                                        <UncontrolledTooltip placement="right" target="av-selected-branches-left-arrow">
                                            User don't have enough permission to perform this action
                                        </UncontrolledTooltip>
                                    )}
                                </Col>
                                <Col md={5} className="overview-card">
                                    <div className="overview-card-header">
                                        <span>Selected Branches</span>
                                        <span className="overview-count">{this.state.selectedBranchIds.length}</span>
                                    </div>
                                    <div className="overview-list">
                                        {this.state.selectedBranchIds.length === 0 ? <div className="overview-no-data">No branches selected.</div> :
                                            <Input
                                                type="select"
                                                multiple
                                                className="overview-select"
                                                value={this.state.selectedSelectedBranchIds}
                                                onChange={(event) => {
                                                    const selected = Array.from(event.target.selectedOptions).map((option) => option.value)
                                                    this.setState({ selectedSelectedBranchIds: selected })
                                                }}
                                            >
                                                {this.state.selectedBranchIds.map((item) => (
                                                    <option key={item.value} value={item.value}>{item.label}</option>
                                                ))}
                                            </Input>
                                        }
                                    </div>
                                </Col>
                            </Row>
                            <Row className="overview-bulk-row">
                                <Col md={5} className="overview-bulk-col"></Col>
                                <Col md={2}></Col>
                                <Col md={5} className="overview-bulk-col">
                                    <span
                                        className={`overview-bulk-link ${!this.state.selectedBranchIds.length || !this.props.hasPermissions?.includes("change_member") ? "is-disabled" : ""}`}
                                        role="button"
                                        tabIndex={0}
                                        onClick={() => {
                                            if (this.state.selectedBranchIds.length && this.props.hasPermissions?.includes("change_member")) {
                                                this.removeAllItems("selectedBranchIds", "selectedSelectedBranchIds")
                                            }
                                        }}
                                    >
                                        <i className="fa fa-chevron-circle-left" aria-hidden="true"></i> Remove All
                                    </span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="overview-section-row">
                        <Col xs={6}>
                            <Row>
                                <Col md={5} className="overview-card">
                                    <div className="overview-card-header">
                                        <span>Available Groups</span>
                                        <span className="overview-count">{availableGroupsAll.length}</span>
                                    </div>
                                    <div className="overview-search">
                                        <Input
                                            className="overview-search-input"
                                            name="groupSearchTerm"
                                            id="groupSearchTerm"
                                            value={this.state.groupSearchTerm}
                                            onChange={this.handleGroupSearchChange}
                                            placeholder="Search groups..."
                                        />
                                    </div>
                                    <div className="overview-list">
                                        {this.props.allGroupsLoading ? (
                                            <div className="overview-list-skeleton">
                                                <Skeleton count={8} height={18} />
                                            </div>
                                        ) : (
                                            filteredAvailableGroups.length === 0 ? <div className="overview-no-data">No groups available.</div> :
                                                <Input
                                                    type="select"
                                                    multiple
                                                    className="overview-select"
                                                    value={this.state.selectedAvailableGroupIds}
                                                    onChange={(event) => {
                                                        const selected = Array.from(event.target.selectedOptions).map((option) => option.value)
                                                        this.setState({ selectedAvailableGroupIds: selected })
                                                    }}
                                                >
                                                    {filteredAvailableGroups.map((item) => (
                                                        <option key={item.value} value={item.value}>{item.label}</option>
                                                    ))}
                                                </Input>
                                        )}
                                    </div>
                                    {this.state.groupsLoadingMore && (
                                        <div className="overview-list-skeleton">
                                            <Skeleton count={4} height={18} />
                                        </div>
                                    )}
                                    {groupsHasNextPage && (
                                        <div className="overview-load-more">
                                            <span
                                                className={`overview-load-link ${(!groupsHasNextPage || this.state.groupsLoadingMore) ? "is-disabled" : ""}`}
                                                role="button"
                                                tabIndex={0}
                                                onClick={() => groupsHasNextPage && !this.state.groupsLoadingMore && this.loadMoreGroups()}
                                            >
                                                Load more
                                            </span>
                                        </div>
                                    )}
                                </Col>
                                <Col md={2} className="overview-transfer">
                                    <Button
                                        onClick={() => this.addSelectedItems("selectedAvailableGroupIds", "assignedGroups", availableGroupsAll, "groupSearchTerm")}
                                        className="transfer-btn"
                                        disabled={!this.props.hasPermissions?.includes("custom_can_edit_member_sensitive_info") || !this.state.selectedAvailableGroupIds.length}
                                        id="group-right-arrow"
                                    >
                                        <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                    </Button>
                                    {!this.props.hasPermissions?.includes("custom_can_edit_member_sensitive_info") && (
                                        <UncontrolledTooltip placement="right" target="group-right-arrow">
                                            User don't have enough permission to perform this action
                                        </UncontrolledTooltip>
                                    )}
                                    <Button
                                        onClick={() => this.removeSelectedItems("selectedAssignedGroupIds", "assignedGroups")}
                                        className="transfer-btn"
                                        disabled={!this.props.hasPermissions?.includes("custom_can_edit_member_sensitive_info") || !this.state.selectedAssignedGroupIds.length}
                                        id="group-left-arrow"
                                    >
                                        <i className="fa fa-chevron-left" aria-hidden="true"></i>
                                    </Button>
                                    {!this.props.hasPermissions?.includes("custom_can_edit_member_sensitive_info") && (
                                        <UncontrolledTooltip placement="right" target="group-left-arrow">
                                            User don't have enough permission to perform this action
                                        </UncontrolledTooltip>
                                    )}
                                </Col>
                                <Col md={5} className="overview-card">
                                    <div className="overview-card-header">
                                        <span>Assigned Groups</span>
                                        <span className="overview-count">{this.state.assignedGroups.length}</span>
                                    </div>
                                    <div className="overview-list">
                                        {this.props.allGroupsLoading ? (
                                            <div className="overview-list-skeleton">
                                                <Skeleton count={8} height={18} />
                                            </div>
                                        ) : (
                                            this.state.assignedGroups.length === 0 ? <div className="overview-no-data">No groups assigned.</div> :
                                                <Input
                                                    type="select"
                                                    multiple
                                                    className="overview-select"
                                                    value={this.state.selectedAssignedGroupIds}
                                                    onChange={(event) => {
                                                        const selected = Array.from(event.target.selectedOptions).map((option) => option.value)
                                                        this.setState({ selectedAssignedGroupIds: selected })
                                                    }}
                                                >
                                                    {this.state.assignedGroups.map((item) => (
                                                        <option key={item.value} value={item.value}>{item.label}</option>
                                                    ))}
                                                </Input>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                            <Row className="overview-bulk-row">
                                <Col md={5} className="overview-bulk-col"></Col>
                                <Col md={2}></Col>
                                <Col md={5} className="overview-bulk-col">
                                    <span
                                        className={`overview-bulk-link ${!this.state.assignedGroups.length || !this.props.hasPermissions?.includes("custom_can_edit_member_sensitive_info") ? "is-disabled" : ""}`}
                                        role="button"
                                        tabIndex={0}
                                        onClick={() => {
                                            if (this.state.assignedGroups.length && this.props.hasPermissions?.includes("custom_can_edit_member_sensitive_info")) {
                                                this.removeAllItems("assignedGroups", "selectedAssignedGroupIds")
                                            }
                                        }}
                                    >
                                        <i className="fa fa-chevron-circle-left" aria-hidden="true"></i> Remove All
                                    </span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex justify-content-end pr-5"><Button onClick={this.updateUser} className="overview-primary-btn" disabled={this.state.disableUpdateBtn}>UPDATE</Button></Col>
                    </Row>
                </>}
            </Container>
        )
    }
}



//-----------------------------------
export default graphql(HasPermissionsQuery, {
    options: () => ({
        variables: { userPermissions: ["custom_can_edit_member_sensitive_info", "change_member"] },
        fetchPolicy: "network-only",
        notifyOnNetworkStatusChange: true,
    }),
    props: ({ data: { hasPermissions, loading, variables } }) => ({
        hasPermissions,
        loading,
        variables,
    }),
})(
    graphql(MembersDetailQuery, {
        options: ({ memberId }) => ({
            variables: { id: memberId },
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'network-only',
        }),
        props: ({ data: { member, loading, refetch, variables } }) => ({
            member,
            loading,
            variables,
            refetchQuery: () => {
                return refetch({
                    query: MembersDetailQuery,
                    variables: { ...variables },
                    updateQuery: (previousResult, { fetchMoreResult }) => ({
                        member: fetchMoreResult.member,
                    }),
                })
            },
        }),
    })(
        graphql(AllBranches, {
            options: () => ({
                notifyOnNetworkStatusChange: true,
                fetchPolicy: 'network-only',
            }),
            props: ({ data }) => ({
                allBranches: data.allBranches,
                allBranchesLoading: data.loading,
            }),
        })(
            graphql(AllGroups, {
                options: () => ({
                    notifyOnNetworkStatusChange: true,
                    fetchPolicy: 'network-only',
                    variables: { first: PAGE_SIZE },
                }),
                props: ({ data }) => ({
                    allGroups: data.allGroups,
                    allGroupsLoading: data.loading,
                    allGroupsRefetch: data.refetch,
                    allGroupsFetchMore: data.fetchMore,
                    allGroupsVariables: data.variables,
                }),
            })(
                graphql(UserPermissions, {
                    options: ({ memberId }) => ({
                        variables: { memberId: memberId },
                        notifyOnNetworkStatusChange: true,
                        fetchPolicy: 'network-only',
                    }),
                    props: ({ data: { userPermissions, loading, refetch, variables } }) => ({
                        userPermissions,
                        userPermissionsLoading: loading,
                        refetchUserPermissionsQuery: () => {
                            return refetch({
                                query: UserPermissions,
                                variables: { ...variables },
                                updateQuery: (previousResult, { fetchMoreResult }) => ({
                                    userPermissions: fetchMoreResult.userPermissions,
                                }),
                            })
                        },
                    }),
                })(withApolloClient(OverviewTab))
            )
        )
    )
)
